import { useEffect } from "react";
import { useSelector } from "react-redux";

const getBrandName = (endpoint) => {
  // Map endpoint to brand name
  const brandMapping = {
    romeolane: "Romeo Lane",
    caha: "Caha",
    skiptheq: "SkipTheQ",
    grillet: "Grillet",
    dogandcrook: 'Dog and Crook',
    ambl: 'AMBL',
    localpubpassport: 'Local Pub Passport',
    skiptheqpassport: 'SkipTheQ Passport',
    charliecafe: 'Charlie Cafe'
  };
  
  return brandMapping[endpoint] || "Romeolane";
};


const getFaviconUrl = (endpoint) => {
  // Map endpoint to favicon URLs
  const faviconMapping = {
    romeolane: "https://romeolane.com/wp-content/uploads/2024/05/logo-1.png",
    caha: "https://instagram.famd21-2.fna.fbcdn.net/v/t51.2885-19/537462151_17859890736470992_8518353046717499637_n.jpg?stp=dst-jpg_s320x320_tt6&efg=eyJ2ZW5jb2RlX3RhZyI6InByb2ZpbGVfcGljLmRqYW5nby4xMDgwLmMyIn0&_nc_ht=instagram.famd21-2.fna.fbcdn.net&_nc_cat=104&_nc_oc=Q6cZ2QHdYbJVtYGq0-FAhOjby6FtM07Ma9oB8rKD0ZV0Ts8WN1j9GWon0wou6mIe4iN6Ve532A1oSfG9hius4-CfRFxk&_nc_ohc=mNsAwbfrujsQ7kNvwHKlg3v&_nc_gid=J8IeMhZE5uhW3piZjKvRfQ&edm=AOQ1c0wBAAAA&ccb=7-5&oh=00_AfdI9lcPoAIm_m4z7o314Sn0k3wropab9VsbaMw9Ke4rLA&oe=690921CF&_nc_sid=8b3546", // Update with actual Caha favicon URL
    grillet: "%PUBLIC_URL%/favicon.ico", // Update with actual Grillet favicon URL
    dogandcrook: "https://dev.dogandcrook.co.uk/wp-content/uploads/2025/05/favicon.png", // Update with actual Dog and Crook favicon URL
    ambl: "%PUBLIC_URL%/favicon.ico", // Update with actual AMBL favicon URL
    skiptheq: "https://skiptheq.co.uk/favicon.ico", // Update with actual SkipTheQ favicon URL
    localpubpassport: "https://localpubpassport.co.uk/wp-content/uploads/2026/04/cropped-logo-pub-passport-1-scaled-1-150x150.png", // Update with actual Local Pub Passport favicon URL
    skiptheqpassport: "%PUBLIC_URL%/favicon.ico", // Update with actual SkipTheQ Passport favicon URL
    charliecafe: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTrmtS_akSLoapzO51p5qe0HTwftejjxNyyLK0HmC42_vugLnEYNIj5Js71&s=10"
  };
  
  return faviconMapping[endpoint] || faviconMapping.romeolane;
};

const updateFavicon = (faviconUrl) => {
  // Remove existing favicon links
  const existingLinks = document.querySelectorAll(
    'link[rel="icon"], link[rel="apple-touch-icon"]'
  );
  existingLinks.forEach((link) => link.remove());

  // Remove msapplication-TileImage meta tag
  const existingMeta = document.querySelector('meta[name="msapplication-TileImage"]');
  if (existingMeta) {
    existingMeta.remove();
  }

  // Add new favicon links
  const link32 = document.createElement("link");
  link32.rel = "icon";
  link32.href = faviconUrl;
  link32.sizes = "32x32";
  document.head.appendChild(link32);

  const link192 = document.createElement("link");
  link192.rel = "icon";
  link192.href = faviconUrl;
  link192.sizes = "192x192";
  document.head.appendChild(link192);

  const appleTouchIcon = document.createElement("link");
  appleTouchIcon.rel = "apple-touch-icon";
  appleTouchIcon.href = faviconUrl;
  document.head.appendChild(appleTouchIcon);

  const tileImage = document.createElement("meta");
  tileImage.name = "msapplication-TileImage";
  tileImage.content = faviconUrl;
  document.head.appendChild(tileImage);
};

export const useDocumentTitle = (pageTitle) => {
  const { endpoint } = useSelector((state) => state.auth);
  
  useEffect(() => {
    const brandName = getBrandName(endpoint);
    const title = pageTitle ? `${brandName} | ${pageTitle}` : brandName;
    document.title = title;

    // Update favicon dynamically
    const faviconUrl = getFaviconUrl(endpoint);
    updateFavicon(faviconUrl);
  }, [endpoint, pageTitle]);
};

